import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { DividerModule } from 'primeng/divider';
import { CurrentUserService } from '@services/currentUser.service';
import { Payment } from '@modules/payments/Domain/payment.model';
import { PipeModule } from '@shared/pipes/pipe.module';
import { Button } from 'primeng/button';
import { RouterLink } from '@angular/router';
import { PAYMENT_METHODS } from '@models/global-entities.model';
import { PaymentGateway } from '@shared/constants/gateway';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentMethod } from '@shared/constants/payment-method';
import { PaymentCatalogStore } from '@shared/services/payment-catalog-store.service';

@Component({
  selector: 'app-payment-details',
  standalone: true,
  imports: [NgIf, DividerModule, PipeModule, Button, RouterLink, NgForOf, TranslateModule],
  templateUrl: './payment-details.component.html',
  styleUrl: './payment-details.component.scss',
})
export class PaymentDetailsComponent implements OnInit {
  @Input() payment!: Payment;
  @Output() closeModal = new EventEmitter<void>();

  private currentUser = inject(CurrentUserService);
  private paymentCatalogStore = inject(PaymentCatalogStore);
  protected readonly PAYMENT_METHODS = PaymentMethod;

  // Signals
  loading = signal(true);
  error = signal<string | null>(null);

  ngOnInit(): void {}

  getMethodName(): string {
    const key = this.payment?.method;
    if (!key) return '';
    return this.paymentCatalogStore.paymentMethods().find((pm) => pm.key === key)?.name ?? key;
  }

  goToClient(id: string) {
    window.open(
      `/customers/customer/${id}?tenant=${this.currentUser.currentUser.tenantId}`,
      '_blank',
    );
  }

  goToOperation(id: string) {
    window.open(
      `/operations/operation/${id}?tenant=${this.currentUser.currentUser.tenantId}`,
      '_blank',
    );
  }
}
